export function getMetadataDictionaryKey(presentationId: string, slideId: string) {
  return `${presentationId}__${slideId}`;
}

export function getPresentationIdAndSlideId(metaDataKey: string) {
  const [presentationId, slideId] = metaDataKey.split('__');
  return { presentationId, slideId };
}
